module.exports = __webpack_public_path__ + "img/3-4.72431c39.svg";